import {
  Component,
  Input,
  computed,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Store } from '@ngrx/store';

import { selectUser } from 'src/app/core/state';
import { AppState } from 'src/app/core/state/app.state';
import {
  NotificationsScope,
  injectLatestNotificationsQuery,
} from 'src/app/api/queries/notification.queries';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { LoadingComponent } from '../../../../shared/components/loading/loading.component';
import { NotificationComponent } from '../../../../shared/components/notification/notification.component';
import { RouterLink } from '@angular/router';
import { SuiButtonComponent } from '@sui/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dropdown-notifications',
  templateUrl: './dropdown-notifications.component.html',
  styleUrls: ['./dropdown-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DropdownComponent,
    LoadingComponent,
    NotificationComponent,
    RouterLink,
    SuiButtonComponent,
    TranslatePipe,
  ],
})
export class DropdownNotificationsComponent {
  @Input() closeMethod!: () => void;

  private readonly store = inject(Store<AppState>);

  private readonly user = this.store.selectSignal(selectUser);

  private readonly scope = computed<NotificationsScope | null>(() => {
    const user = this.user();

    return user?.id
      ? { userId: user.id, companyId: user.active_company_id }
      : null;
  });

  private readonly notificationsQuery = injectLatestNotificationsQuery(
    this.scope,
  );

  readonly notifications = computed(() => this.notificationsQuery.data() ?? []);
  readonly notificationsLoading = this.notificationsQuery.isLoading;
  readonly notificationCount = computed(() => this.notifications().length);
}
